module.exports = __webpack_public_path__ + "static/media/padi-black.47a7fb23.png";